export const SET_IDENTIFIERS = 'OS_IDENTIFIERS/SET_IDENTIFIERS';
